// extracted by css-extract-rspack-plugin
export default {"NativeCardText":"kCVNV","NativeCardIcon":"Ck00M","NativeCardLink":"ci0x3"};